import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { dateFormation, isEmpty } from "../../common/cores";
import { GetNoticeList } from "../../common/actions/moreAction";
import Pagenation from "../common/Pagenation";
const RuleContent = props => {
  const { page, notices } = props;
  const [showHis, setShowHis] = useState(false);
  // const [ notice , setNotice ] = useState({})
  const [active, setActive] = useState(-1);

  const showHisotry = () => {
    setShowHis(!showHis);
  };
  const getMessage = page => {
    if (page > 0) {
      const params = {
        page: page,
        perPage: 10
      };
      props.GetNoticeList(params);
    }
  };

  const onNotice = index => {
    // setNotice(notices[index]);
    setActive(index);
    showHisotry();
  };

  const notice = notices[active];

  useEffect(() => {
    getMessage(1);
  }, []);

  return (
    <Fragment>
      <div className="contents_wrap">
        <div className="contents_box">
          <div className="con_box00">
            <table
              width="100%"
              border="0"
              cellSpacing="0"
              cellPadding="0"
              style={{ borderSpacing: "0px", cursor: "pointer" }}
            >
              <tbody>
                <tr>
                  <td width="13%" className="list_title1">
                    번호
                  </td>
                  <td className="list_title1">제목</td>
                  <td width="10%" className="list_title1">
                    날짜
                  </td>
                </tr>
                {!isEmpty(notices) &&
                  notices.map((item, index) => {
                    return (
                      <Fragment key={index}>
                        <tr key={index}>
                          <td className="list1">{index + 1}</td>
                          <td className="list1" onClick={() => onNotice(index)}>
                            <span className="font06" dangerouslySetInnerHTML={{
                              __html: !isEmpty(item.title) && item.title
                            }}>
                            </span>
                          </td>
                          <td className="list1">
                            {!isEmpty(item.created_date) &&
                              dateFormation(item.created_date)}
                          </td>
                        </tr>
                        {active === index && (
                          <tr>
                            <td colSpan="4"
                              style={{
                                borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
                                width: "100%",
                                textAlign: "center"
                              }}
                            >
                              <div className="notice-div white-break-spaces"
                                dangerouslySetInnerHTML={{
                                  __html: item.content
                                }}
                              />
                            </td>
                          </tr>
                        )}
                      </Fragment>
                    );
                  })}
              </tbody>
            </table>
          </div>

          <Pagenation
            page={page.curPage}
            totalPage={page.totalPage}
            getPage={getMessage}
            perPage={10}
          />
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = state => ({
  page: state.page,
  notices: state.more.notice.notices
});

export default connect(
  mapStateToProps,
  {
    GetNoticeList
  }
)(RuleContent);



// WEBPACK FOOTER //
// ./src/components/account/RuleContent.js